// extracted by mini-css-extract-plugin
export default {"resendDiv":"otp_resendDiv__l+K8I","timer":"otp_timer__OjVrI"};